var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H2C.9 0 0 .9 0 2v16l7-3 7 3V2c0-1.1-.9-2-2-2m0 15-5-2.18L2 15V3c0-.55.45-1 1-1h8c.55 0 1 .45 1 1z"
  })));
};
export default SvgBookmark;